import React from "react";

export const GooglePlayIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  viewBox = "0 0 466 511.98",
  ...props
}) => (
  <svg viewBox={viewBox} {...props}>
    <g id="Layer_x0020_1">
      <path fill="#EA4335" d="M199.9 237.8l-198.5 232.37c7.22,24.57 30.16,41.81 55.8,41.81 11.16,0 20.93,-2.79 29.3,-8.37l0 0 244.16 -139.46 -130.76 -126.35z" />
      <path fill="#FBBC04" d="M433.91 205.1l0 0 -104.65 -60 -111.61 110.22 113.01 108.83 104.64 -58.6c18.14,-9.77 30.7,-29.3 30.7,-50.23 -1.4,-20.93 -13.95,-40.46 -32.09,-50.22z" />
      <path fill="#34A853" d="M199.42 273.45l129.85 -128.35 -241.37 -136.73c-8.37,-5.58 -19.54,-8.37 -30.7,-8.37 -26.5,0 -50.22,18.14 -55.8,41.86 0,0 0,0 0,0l198.02 231.59z" />
      <path fill="#4285F4" d="M1.39 41.86c-1.39,4.18 -1.39,9.77 -1.39,15.34l0 397.64c0,5.57 0,9.76 1.4,15.34l216.27 -214.86 -216.28 -213.46z" />
    </g>
  </svg>
);

export const AppleIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  viewBox = "0 0 24 24",
  fill = "currentColor",
  ...props
}) => (
  <svg viewBox={viewBox} fill={fill} {...props}>
    <path d="M17.564 12.65c-.028-2.86 2.335-4.234 2.442-4.3-1.331-1.945-3.402-2.211-4.14-2.242-1.762-.178-3.44 1.038-4.335 1.038-.9 0-2.279-1.013-3.746-.985-1.927.028-3.703 1.121-4.696 2.845-2.001 3.468-.512 8.596 1.437 11.412.955 1.379 2.093 2.928 3.586 2.872 1.44-.057 1.984-.933 3.723-.933 1.738 0 2.229.933 3.751.9 1.549-.025 2.53-1.406 3.477-2.79 1.096-1.6 1.548-3.15 1.577-3.23-.035-.014-3.024-1.16-3.076-4.587zM14.712 4.35C15.51 3.38 16.05 2.03 15.902.678c-1.157.05-2.56.771-3.386 1.744-.74.86-1.386 2.235-1.212 3.56 1.29.1 2.61-.657 3.408-1.632z" />
  </svg>
);

export const PhotoCameraIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  viewBox = "0 0 24 24",
  fill = "none",
  stroke = "currentColor",
  strokeWidth = 2,
  strokeLinecap = "round",
  strokeLinejoin = "round",
  ...props
}) => (
  <svg
    viewBox={viewBox}
    fill={fill}
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
    {...props}
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);

export const VideoCameraIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  viewBox = "0 0 24 24",
  fill = "none",
  stroke = "currentColor",
  strokeWidth = 2,
  strokeLinecap = "round",
  strokeLinejoin = "round",
  ...props
}) => (
  <svg
    viewBox={viewBox}
    fill={fill}
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
    {...props}
  >
    <polygon points="23 7 16 12 23 17 23 7" />
    <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
  </svg>
);
